export default __webpack_public_path__ + "static/media/ruby-find.caa2d27a.png";